import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { ClienteService } from '../../../../services/cliente/cliente.service';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TipoEncuesta } from '../../../../models/tipo/tipo-encuesta.class';
import { AgenteService } from '../../../../services/agente/agente.service';
import { DialogService } from '../../../../services/dialog/dialog.service';
import { MensajeInformativoDialogComponent } from '../../dialogs/mensaje-informativo-dialog/mensaje-informativo-dialog.component';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Configuracion } from '../../../../contants/configuracion.constant';

@Component({
  selector: 'pregunta-encuesta-dialog',
  templateUrl: './pregunta-encuesta.component.html',
  styleUrls: ['./pregunta-encuesta.component.css']
})
 
export class PreguntaEncuestaDialogComponent implements OnInit {
 
    listTipoEncuesta: TipoEncuesta[] = [new TipoEncuesta('01', 'Oferta aceptada', 
    Configuracion.URL_OBERVATORIO_OFERTA_ACEPTADA), 
    new TipoEncuesta('02', 'Oferta rechazada', 
    Configuracion.URL_OBERVATORIO_OFERTA_RECHAZADA)];
    tipoEncuestaSeleccionada: TipoEncuesta = null;
    toggleEncuesta: Boolean = false;
    codigoAsesor: String;
    tipoEncuestaForm = new FormGroup({
      tipoEncuestaControl: new FormControl(null, [Validators.required])
    });
  
    constructor(private agenteService: AgenteService, private dialogService: DialogService, private sanitizer: DomSanitizer) { }
 
    ngOnInit() {
        this.tipoEncuestaSeleccionada = null;
        this.toggleEncuesta = false;
    }
  
  
    formularioValido() {
      return this.tipoEncuestaForm.status === 'VALID' ? true : false;
    }
 
    cerrarEncuesta() {
      this.toggleEncuesta = !this.toggleEncuesta;
    }
  
    desplegarEncuesta() {
      if (this.formularioValido()) {
        this.codigoAsesor = this.agenteService.obtenerCodigoAsesor();
        if(this.codigoAsesor) {
          this.toggleEncuesta = !this.toggleEncuesta;
        } else {
          this.dialogService.open(MensajeInformativoDialogComponent, {
            mensaje: 'Antes de diligenciar la encuesta, debe seleccionar un código de asesor ( sección superior derecha ).'
          });
        }
      }
    }

    getUrl(): SafeUrl {
      if(this.tipoEncuestaSeleccionada && this.listTipoEncuesta.find(te => te.id == this.tipoEncuestaSeleccionada.id)){
        let url = this.listTipoEncuesta.find(te => te.id == this.tipoEncuestaSeleccionada.id).url
        if(url){
          url = url + this.codigoAsesor;
          return this.sanitizer.bypassSecurityTrustResourceUrl(url);
        } else {
          return this.sanitizer.bypassSecurityTrustResourceUrl('#');
        }
      }
    }
  }


// WEBPACK FOOTER //
// ./src/app/components/shared/encuesta/modal/pregunta-encuesta.component.ts